/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetSubscriptionResponseFromJSON, GetSubscriptionResponseToJSON, } from './GetSubscriptionResponse.js';
/**
 * Check if a given object implements the GetSubscriptionResult interface.
 */
export function instanceOfGetSubscriptionResult(value) {
    return true;
}
export function GetSubscriptionResultFromJSON(json) {
    return GetSubscriptionResultFromJSONTyped(json, false);
}
export function GetSubscriptionResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'subscription': json['subscription'] == null ? undefined : GetSubscriptionResponseFromJSON(json['subscription']),
    };
}
export function GetSubscriptionResultToJSON(json) {
    return GetSubscriptionResultToJSONTyped(json, false);
}
export function GetSubscriptionResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'subscription': GetSubscriptionResponseToJSON(value['subscription']),
    };
}
